// extracted by mini-css-extract-plugin
var _1 = "EmailRecipientsFilterModal-modulebox__qsrFw";
var _2 = "EmailRecipientsFilterModal-modulecontainer__jtKYS";
var _3 = "EmailRecipientsFilterModal-moduleheader__fV8zP";
export { _1 as "box", _2 as "container", _3 as "header" }
